export const development = {
    clientKey: 'sdk-drAfMf7Qd3jF9Cvc',
    enableDevMode: true,
    disableCache: true,
};
export const production = {
    clientKey: 'sdk-Cp30MODyJUeDHx',
    enableDevMode: false,
};
